export enum BulkActionName {
  assignRole = 'assignRole',
  changeStatus = 'changeStatus',
  detachRole = 'detachRole',
  export = 'export',
  remove = 'remove',
}
